import { MarkovDataset } from "server/models"
import { inferLiteral } from "client/utils"
import * as types from "./types"


export const setMarkovDatasets = (datasets: MarkovDataset[]) => ({
    type: inferLiteral(types.MARKOV_DATASETS),
    datasets,
})
export const setMarkovDatasetSelected = (dataset: MarkovDataset) => ({
    type: inferLiteral(types.MARKOV_DATASET_SELECTED),
    dataset,
})
export const setMarkovDatasetEdit = (dataset: MarkovDataset) => ({
    type: inferLiteral(types.MARKOV_DATASET_EDIT),
    dataset,
})
export const setMarkovDatasetReloadList = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_DATASET_RELOAD_LIST),
    value,
})
export const setMarkovDatasetReloadEdit = (value: boolean) => ({
    type: inferLiteral(types.MARKOV_DATASET_RELOAD_EDIT),
    value,
})
